function currentAttempt(state, feedback) {
  const attempts = (state && state.attempts) || [];
  const currentIndex = (attempts.length || 1) - 1;
  const selection = attempts[currentIndex];
  const attemptIndex = feedback.retry || 0;
  const reviewing = feedback.complete || currentIndex < attemptIndex;

  return {
    selection,
    currentIndex,
    attemptIndex,
    reviewing,
  };
}

export { currentAttempt };
